import React from 'react';
import { Link } from 'react-router-dom';
import { groupOffices } from '../utils/officeGroups';

/**
 * 運営事業所ドロップダウン（2段階）
 * - 未分類の事業所は直接リンク表示
 * - グループ（サービス種別）はクリックするとグループ専用ページを開く
 * - グループ表示順は groupOrder に従う
 */
export const GroupedOfficeMenu = ({ offices = [], groupOrder = [], onNavigate, className = '' }) => {
  const groups = groupOffices(offices, groupOrder);

  return (
    <ul
      className={`absolute left-0 top-full mt-2 w-60 max-h-80 overflow-y-auto bg-white/95 backdrop-blur-md border border-amber-500/30 rounded-lg shadow-lg z-50 animate-in fade-in slide-in-from-top-2 duration-300 ${className}`}
      data-testid="offices-dropdown-menu"
    >
      {groups.map((g) => {
        if (!g.group) {
          return (
            <React.Fragment key="__ungrouped">
              {g.items.map((office) => (
                <li key={office.id}>
                  <Link
                    to={`/offices/${office.id}`}
                    onClick={onNavigate}
                    className="flex items-center gap-3 px-4 py-2 text-sm text-gray-600 hover:text-amber-500 hover:bg-amber-500/10 transition-colors"
                    data-testid={`nav-office-${office.id}`}
                  >
                    <span>{office.name}</span>
                  </Link>
                </li>
              ))}
            </React.Fragment>
          );
        }

        return (
          <li key={g.group}>
            <Link
              to={`/offices/group/${encodeURIComponent(g.group)}`}
              onClick={onNavigate}
              className="flex items-center gap-3 px-4 py-2 text-sm text-gray-600 hover:text-amber-500 hover:bg-amber-500/10 transition-colors"
              data-testid={`nav-group-${g.group}`}
            >
              <span>{g.group}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default GroupedOfficeMenu;
